import "./styles.less";

const HeadlineFlex = (props) => {
  const {
    colorOne = "",
    titleOne = "",
    colorTwo = "",
    titleTwo = "",
    colorThree = "",
    titleThree = "",
  } = props;

  return (
    <div className="headlineFlex">
      {titleOne && (
        <p className="first" style={{ color: colorOne }}>
          {titleOne}
        </p>
      )}
      {titleTwo && (
        <p className="second" style={{ color: colorTwo }}>
          {titleTwo}
        </p>
      )}
      {titleThree && (
        <p className="thirdly" style={{ color: colorThree }}>
          {titleThree}
        </p>
      )}
    </div>
  );
};

export default HeadlineFlex;